import React from "react";

const State = () => {
  return (
    <div>

      {/* HERO */}
      <section className="hero">
        <div className="container">
          <h1>State Government Subsidy</h1>
          <p>Support for state industrial incentive schemes</p>
        </div>
      </section>

      {/* CONTENT */}
      <section className="section">
        <div className="container">

          <h2>State Subsidy Assistance</h2>

          <p>
            Many state governments offer incentives for manufacturing
            industries, startups and MSMEs. We help businesses obtain
            these benefits smoothly.
          </p>

          <br />

          <div className="card">
            <h3>Services Covered</h3>
            <p>✔ Capital subsidy</p>
            <p>✔ Interest subsidy</p>
            <p>✔ Stamp duty reimbursement</p>
            <p>✔ Power tariff subsidy</p>
          </div>

        </div>
      </section>

    </div>
  );
};

export default State;
